
'use strict'

class WhatWeDoAreas{
    constructor(){
        this.main = document.querySelector('.section_practice_areas');
        
        this._inputSearch = this.main.querySelector('input[name="search"]');
        this._searchBtn = this.main.querySelector('a.form__input-btn');

        this._areas = Array.from(this.main.querySelectorAll('.card-expander')).map((element, index)=>{
            return new WhatWeDoAreasArea(element, index);
        });

        this._counter = this.main.querySelector('.counter');

        this._counter.innerHTML = this._areas.length;

        this._current = null;
        
        this._searchBtn.addEventListener('click', this._onClickSearchBtn.bind(this));
        this._inputSearch.addEventListener('input', this._onInputSearchChange.bind(this));
        this.main.addEventListener('WHAT_WE_DO_AREA_OPEN', this._onAreaOpen.bind(this));
    }

    _onClickSearchBtn(e){
        e.preventDefault();

        this._search();
    }

    _onInputSearchChange(e){
        this._search();
    }
    
    _onAreaOpen(e){
        //console.log('_onAreaOpen:', this._current, e.detail.index);
        e.stopPropagation();
        if(this._current != null && this._current != e.detail.index){
            this._areas[this._current].close();
        }

        this._current = e.detail.index;
    }

    _search(){
        let search = this._inputSearch.value.trim().toUpperCase();
        
        if(search == ''){
            this._areas.forEach((area)=>{
                area.show();
            })

            this._counter.innerHTML = this._areas.length;
        }else{
            let count = 0;
            this._areas.forEach((area)=>{
                if(area.name.indexOf(search) != -1){
                    count++;
                    area.show();
                }else{
                    area.hide();
                }
            })

            if(count == 0){
                this.main.classList.add('page--no-results');
            }else{
                this.main.classList.remove('page--no-results');
            }

            setTimeout(()=>{
                App.wow.sync();
                App.updateSize();
            }, 0)

            this._counter.innerHTML = count;
        }
    }
}

class WhatWeDoAreasArea{
    constructor(element, index){
        this.main = element;
        this.name = this.main.querySelector('.card-expander__name').innerHTML.toUpperCase();

        this._isOpen = false;
        this._index = index;

        this.main.querySelector('.card-expander__header').addEventListener('click', this._onClickHeader.bind(this));
        this.main.querySelector('.card-expander__icon').addEventListener('click', this._onClickHeader.bind(this));
        this.main.querySelector('.card-expander__close').addEventListener('click', this._onClickCloseBtn.bind(this));
    }

    show(){
        this.main.parentNode.style.display = 'block';
        this.main.style.visibility = 'visible';
    }

    hide(){
        this._isOpen = false; 
        this.main.classList.remove('card-expander--expand');
        this.main.classList.remove('card-expander--anim');
        
        this.main.parentNode.style.display = 'none';
        this.main.style.visibility = 'hidden';
    }

    close(){
        //console.log('close:')
        if(this._isOpen){
            this._isOpen = false; 
            this.main.classList.remove('card-expander--expand');
            this.main.classList.remove('card-expander--anim');
        }
    }

    _onClickHeader(e){
        e.stopPropagation();
        if(!this._isOpen){
            this._isOpen = true; 
            this.main.classList.add('card-expander--expand');

            setTimeout(() => {
                this.main.classList.add('card-expander--anim');
            }, 50);
            
            this.main.dispatchEvent(new CustomEvent('WHAT_WE_DO_AREA_OPEN', {bubbles: true, detail: {index: this._index}}));
        } else {
            this.close();
        }
    }

    _onClickCloseBtn(e){
        e.preventDefault();
        e.stopPropagation();

        this.close();
    }
}


export default WhatWeDoAreas;